import React from 'react';
import { Tag } from '@shared/models/tags.models';
import { Column } from "../../../atoms/StructuralLayout";
import { BodyRegular } from "../../../atoms/fonts/Body";
import styled from "styled-components";
import { desktopSmall } from "../../../atoms/MediaQueries";
import IconButton, { IconButtonProps } from "../../../molecules/icon-button/IconButton";
import { isInTeamsStoreApp } from '@shared/utils/TeamsUtils';
import { useDispatch } from "react-redux";
import { DialogIdentifiers, openDialogWithPayload } from '@shared/store/dialog.duck';
import { IconTypes } from "../../../atoms/icon/Icon";

export function EditTagMovementsRow(props: Props) {
  const {tag} = props;
  const dispatch = useDispatch();
  const onEditGroupClicked = () => {
    dispatch(openDialogWithPayload({
      payload: { tag: tag },
      activeDialog: DialogIdentifiers.EditUsersInTagDialog
    }));
  }
  return (
    <Row>
      <Column>
        <BodyRegular weight={600}>{tag.label}</BodyRegular>
      </Column>

      {!isInTeamsStoreApp() && <EditButton dataTest="editWorkGroupButton" onClick={onEditGroupClicked} icon={IconTypes.Edit} text="edit-workgroup.edit-workgroup"/>}
    </Row>
  )
}

interface Props {
  tag: Tag;
}

const Row = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  padding: 0;
  margin-top: 8px;
  @media (${desktopSmall}) {
    margin-top: 0;
    padding: 16px;
  }
`

const EditButton = styled(IconButton)<IconButtonProps>`
  justify-self: flex-end;
  margin-left: auto;
  i {
    font-size: 30px;
  }
`
